const data=[
    {
    id:1,
    ques:"JVL full form is:",
    a:"Java virtual Machine",
    b:"Java Valuable Machine",
    c:"Java virtual memory",
    d:"Java virus memory",
    
},
{
    id:2,
    ques:"Syntax of declaring array",
    a:"int arr[]=new int[]",
    b:"int arr[]=int[n]",
    c:"int arr=new int[]",
    d:"None od these"
},
{
    id:3,
    ques:"Output of ++i when i=0",
    a:"0",
    b:"1",
    c:"2",
    d:"none of these"
},
{
    id:4,
    ques:"Name any two access modifier",
    a:"public and private",
    b:"int and long",
    c:"char and bool",
    d:"true and false"
},
]
export default data;